import React, { useContext, useEffect } from "react";
import "./MobileCategory.css";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { ThemeContext } from "../../Contexts/ThemeContext";
import MobileFoodCare from "./MobileCatefories/MobileFoodCare"; // ✅ This will act as SHOP now

const MobileCategory = ({ menu, handleMenu }) => {
  const { setCategory } = useContext(ThemeContext);
  const location = useLocation();

  useEffect(() => {
    // ✅ Auto-close menu when route changes
    handleMenu(false);
  }, [location.pathname]);

  return (
    <div
      className={`mobile-category-container ${
        menu ? "" : "mobile-category-container-left"
      }`}
      aria-label="Clariss Food Categories Drawer"
    >
      {/* ✅ Close Button */}
      <FontAwesomeIcon
        icon={faXmark}
        onClick={() => handleMenu(false)}
        className="block ml-auto w-[24px] h-[24px] m-4 text-accent cursor-pointer"
        aria-label="Close Menu"
      />

      <div className="mobile-category">
        {/* ✅ SHOP - Food Categories */}
        <MobileFoodCare />

        {/* ✅ Other Pages */}
        <br />
        <Link to="/blogs" className="mr-10 block font-bold">
          BLOGS
        </Link>

        <br />
        <Link to="/about" className="mr-10 block font-bold">
          ABOUT US
        </Link>
      </div>
    </div>
  );
};

export default MobileCategory;
